/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Jumpy_Pigeon_CutInputs */

const fr_simple_jumpy_pigeon_cut = /** @type {(inputs: Simple_Jumpy_Pigeon_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la section`)
};

/**

* @param {Simple_Jumpy_Pigeon_CutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const simple_jumpy_pigeon_cut = /** @type {((inputs?: Simple_Jumpy_Pigeon_CutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Jumpy_Pigeon_CutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_simple_jumpy_pigeon_cut(inputs)
});